var _g, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCzech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: "100px",
    id: "Albania",
    viewBox: "0 0 100 100",
    width: "100px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "#FFFFFF",
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.001,50.001C0,77.613,22.387,100,50,100c27.615,0,50-22.387,50-49.999H-0.001z",
    fill: "#E00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.469,23.714C2.737,31.352-0.001,40.354-0.001,50c0,9.646,2.738,18.648,7.47,26.287L50,50.001   L7.469,23.714z",
    fill: "#0000C4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: -1150.0137,
    cy: 7049.0078,
    gradientTransform: "matrix(-1 0 0 -1 -1100.0137 7099.0078)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    r: 50
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.5
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    enableBackground: "new    ",
    fill: "url(#SVGID_1_)",
    opacity: 0.4,
    r: 50
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-0.7 0 0 -0.5 -1200.1115 6931.0508)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    x1: -1785.8726,
    x2: -1785.8726,
    y1: 13766.1016,
    y2: 13850.1016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,27.001C19,15.401,32.879,6,49.998,6c17.121,0,31.001,9.401,31.001,21.001   C80.999,38.598,67.119,48,49.998,48C32.879,48,19,38.598,19,27.001z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-0.7 0 0 0.5 -1200.1115 -235.5449)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    x1: -1785.873,
    x2: -1785.873,
    y1: 671.0898,
    y2: 617.6787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.998,75.404c19.888,0,36.001-6.578,36.001,3.498S69.886,100,49.998,100   C30.116,100,14,88.979,14,78.902C14,68.825,30.116,75.404,49.998,75.404z",
    fill: "url(#SVGID_3_)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzech);
export default __webpack_public_path__ + "static/media/czech.e6df583b9cc1d1780e28f978e6b37238.svg";
export { ForwardRef as ReactComponent };